// Header lines for a resource: "name (resource id)" over "agnostic / native"
// type, skipping parts that are missing instead of printing "undefined".
export const getResourceHeaderLabels = (insight?: Record<string, any>) => {
  const { name, resource_id, agnostic_display_name, native_display_name } =
    insight ?? {};
  return {
    upper: name
      ? `${name}${resource_id ? ` (${resource_id})` : ''}`
      : resource_id ?? '',
    lower: [agnostic_display_name, native_display_name]
      .filter(Boolean)
      .join(' / '),
  };
};
